import { Helmet } from "react-helmet-async";

const SITE_NAME = "Guia do Povo";
const SITE_URL = "https://guiadopovo.com";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;
const DEFAULT_DESCRIPTION = "Guia do Povo - Dados, Política e Notícias para o Cidadão";

/**
 * Per-page title/description/canonical + Open Graph/Twitter tags.
 * Without this, every route shares the same generic <title>, which makes
 * it impossible for Google to tell pages apart.
 */
export default function SEO({ title, description = DEFAULT_DESCRIPTION, path = "", image, type = "website", jsonLd, noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Dados, Política e Notícias`;
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  if (noindex) {
    return (
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
